import React from 'react';

import Page from "../../../components/Page";
import {
	Container, makeStyles
} from "@material-ui/core";
import SuspiciousGraph from "./SuspiciousGraph";
import DailyEventsGraph from "./DailyEventsGraph";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingTop: theme.spacing(3)
	},
	dataTable: {
		maxHeight: "500px",
		overflowY: "scroll"
	}
}));

const StatisticsDashboard = () => {

	const classes = useStyles();
	const {t}  = useTranslation();

	return (
		<Page className={classes.root} title={t('Statistics')}>
			<Container maxWidth={false}>
				<SuspiciousGraph dataTableClass={classes.dataTable} />
				<DailyEventsGraph />
			</Container>
		</Page>
	);
};

export default StatisticsDashboard;